import Category from "../components/products/Category"
import { useLoaderData, Await, defer } from "react-router-dom"
import { Suspense } from "react"
import LoadingWrapper from "../components/common/LoadingWrapper"
import { getMenuFromLocationId, getProductFromID } from "../scripts/fetchApi"
import { getItemFromStorage, setStorageItem } from "../scripts/localStorage"

const CategoriesDetails = () => {
    const data = useLoaderData() 

    return <Suspense fallback={<LoadingWrapper text=""/>}>
        {/* Preparing your personal restaurant! Please wait */}
        <Await resolve={data.data}>
            {() => <>
                <Category />
            </>}        
        </Await>
    </Suspense>
}

export default CategoriesDetails



async function loadData(slug, prodID) {
    const storage = getItemFromStorage('currentLocation') 
    const fetchLocation = async () => {
    
        const loc = await getMenuFromLocationId(slug)
        console.log('location in Location page::: ', loc)
        if (!loc.id) {
            throw new Response("Not Found", { status: 404 });
        } else {
            
            setStorageItem('currentLocationId', {
                currentLocationId: loc.id,
                currentLocationSlug: loc.slug
            }, null) 

            setStorageItem('currentMenu', {
                // menu: menu
                menu: loc
            }, 3600) 
            setStorageItem('currentLocation', {
                currentLocation: loc,
                deliveryType: 'pickup',
            }, 3600) 
            
            // make a cart on landing 
            // const storageCart = getItemFromSessionStorage('currentCart')
            
            // if (!storageCart || (storageCart && storageCart.vendorid !== loc.id.id)) {
            //     const newCart = await createCart({restaurant_id: loc.id})
            //     // setStorageItem('currentCart', newCart)
            //     setSessionStorageItem('currentCart', newCart)
            // }  

            if (prodID !== null) {
                const product = await getProductFromID(loc.id, prodID)
    
                // console.log('product in LocationPage::::: ', product)
    
                if (product.id) {
                    setStorageItem('foundProduct', {
                        product : product
                    })
        
                    return {menu: loc, prodDetails: product}
                } else {
                    throw new Response("Not Found", { status: 404 });
                }
            }
    
            return loc
        }
        
    }

    
    if (storage === null) {    // there is nothing in storage = search location 
        const menu = fetchLocation()    
        return menu
    } else {  // there is a location 
        if (storage.currentLocation.slug !== slug) { // the location in storage does not match the slug
            sessionStorage.removeItem('wasWarningShown')
            const menu = await fetchLocation()                 
            return menu
        }
        if (prodID !== null) {
            const product = await getProductFromID(getItemFromStorage('currentMenu').menu.id, prodID)

            if (!product.id) {
                throw new Response("Not Found", { status: 404 });
            } else {
                setStorageItem('foundProduct', {
                    product : product
                })
    
                return {
                    menu: getItemFromStorage('currentMenu').menu, 
                    prodDetails: product
                }
            }            
        }

        return {
            menu: getItemFromStorage('currentMenu').menu
        }
    }
}

export async function loader({ request, params}) {

    const slug = params.locationSlug
    const prodID = params.productSlug || null
    
    return defer({
        data: loadData(slug, prodID)
    })    
}